<template>
  <div class="my-address">
    <div class="top"></div>
    <van-nav-bar
      title="地址管理"
      left-text="返回"
      left-arrow
      :fixed="true"
      @click-left="back"
    />
    <div class="my-bg">
      <div
        class="bg"
        :style="{backgroundImage: `url(${bg})`}"
      >
      </div>
    </div>
    <div class="address-box">
      <div v-if="list.length > 0">
        <van-address-list
          v-model="chosenAddressId"
          :list="list"
          default-tag-text="默认"
          @add="newAddress"
          @edit="editAddress"
        />
      </div>
      <div
        class="empty-box"
        v-else
      >
        <van-empty
          description="没有地址，去添加！"
          image="https://img.yzcdn.cn/vant/custom-empty-image.png"
        >
          <van-button
            round
            type="info"
            class="bottom-button"
            @click="newAddress"
          >
            新增地址
          </van-button>
        </van-empty>
      </div>

    </div>

  </div>
</template>

<script>
import "../assets/less/address.less";
export default {
  data() {
    return {
      // 地址id
      chosenAddressId: "",
      // 地址列表数据
      list: [],
      bg: "",
    };
  },

  created() {
    // 查询收货地址
    this.getReceiveAddress();

    // 获取用户背景图
    this.getBg();
  },

  methods: {
    // 返回
    back() {
      this.$router.push({ name: "My" });
    },

    // 获取用户背景图片
    getBg() {
      // 获取token字符串
      let tokenString = localStorage.getItem("TK");
      if (!tokenString) {
        return;
      }

      this.axios({
        method: "GET",
        url: "/findMy",
        params: {
          appkey: this.appkey,
          tokenString,
        },
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == "A001") {
            this.bg = result.data.result[0].userBg;
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 查询收货地址
    getReceiveAddress() {
      // 获取token字符串
      let tokenString = localStorage.getItem("TK");
      if (!tokenString) {
        return this.$router.push({ name: "Login" });
      }

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        method: "GET",
        url: "/findAddress",
        params: {
          appkey: this.appkey,
          tokenString,
        },
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == 20000) {
            result.data.result.map((v) => {
              let address = v.province + v.city + v.county + v.addressDetail;
              this.list.push({
                id: v.aid,
                name: v.name,
                tel: v.tel,
                address,
                isDefault: Boolean(v.isDefault),
              });
            });
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 新增地址
    newAddress() {
      this.$router.push({ name: "NewAddress" });
    },

    // 编辑地址
    editAddress(item) {
      this.$router.push({ name: "NewAddress", query: { aid: item.id } });
    },
  },
};
</script>